import React from "react";

/** 点赞超过该值时在正文首行展示「火」标 */
export const VIEWPOINT_HOT_LIKE_THRESHOLD = 10000;

export function ViewpointHotBadge({ likeCount }: { likeCount: number }) {
  if (likeCount <= VIEWPOINT_HOT_LIKE_THRESHOLD) {
    return null;
  }
  return <span className="lf-vp-card__hot-badge">火</span>;
}
